interface LinkItem {
  id: number;
  title: string;
  cover?: string;
  description?: string;
  callToAction?: string;
  linkCallToAction?: string;
}

interface Props {
  links: LinkItem[];
  heading?: string;
}

export default function MinisiteLinks({ links, heading }: Props) {
  if (!links.length) return null;

  return (
    <section className="space-y-3">
      {heading && (
        <h2 className="font-bold text-foreground text-xl">{heading}</h2>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {links.map((link) => (
          <article
            key={link.id}
            className="rounded-2xl border bg-card overflow-hidden"
          >
            {link.cover && (
              <img
                src={link.cover}
                alt={link.title}
                className="h-28 w-full object-cover"
              />
            )}
            <div className="p-4">
              <h2 className="font-semibold text-card-foreground">
                {link.title}
              </h2>
              {link.description && (
                <p className="mt-1 text-sm text-muted-foreground">
                  {link.description}
                </p>
              )}
              {link.linkCallToAction ? (
                <a
                  href={link.linkCallToAction}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-2 inline-block text-sm font-medium text-primary hover:underline"
                >
                  {link.callToAction || link.linkCallToAction}
                </a>
              ) : (
                link.callToAction && (
                  <p className="mt-2 text-sm font-medium text-primary">
                    {link.callToAction}
                  </p>
                )
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
